export function ContextMenu(Highcharts) {
    Highcharts.wrap(Highcharts.Chart.prototype, 'firstRender', function (proceed) {
        proceed.call(this);
        const chart = this;
        const container = this.container;
        const plotLeft = this.plotLeft;
        const plotTop = this.plotTop;
        const plotWidth = this.plotWidth;
        const plotHeight = this.plotHeight;
        const inverted = this.inverted;
        const pointer = this.pointer;
        container.oncontextmenu = function (e) {
            const hoverPoint = chart.hoverPoint;
            const chartPosition = pointer.chartPosition;
            this.rightClick = true;
            e = pointer.normalize(e);
            e.cancelBubble = true;
            e.returnValue = false;
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            if (e.preventDefault) {
                e.preventDefault();
            }
            if (!pointer.hasDragged) {
                if (hoverPoint &&
                    pointer.inClass(e.target, 'highcharts-tracker')) {
                    const plotX = hoverPoint.plotX;
                    const plotY = hoverPoint.plotY;
                    Highcharts.extend(hoverPoint, {
                        pageX: chartPosition.left +
                            plotLeft +
                            (inverted ? plotWidth - plotY : plotX),
                        pageY: chartPosition.top +
                            plotTop +
                            (inverted ? plotHeight - plotX : plotY),
                    });
                    Highcharts.fireEvent(hoverPoint.series, 'contextmenu', Highcharts.extend(e, {
                        point: hoverPoint,
                    }));
                    hoverPoint.firePointEvent('contextmenu', e);
                }
            }
        };
    });
}
//# sourceMappingURL=context-menu.js.map